<div class="combatPanel" data-help="combat">
	<ActivityBox />

	<ConcurrentBox />

	<!-- maintained box -->
	{#each maintains as maintained}
		<p class="maintained">{maintained.text}</p>
	{/each}

	<!-- prepared activity box -->
	<fieldset id="preparedBox" data-help="prepared" class="activityarea">
		<h3>Anschließend</h3>
		<img class="close button" src="/static/buttons/close.png" alt="close" onclick={change_prepared.bind('clear')}>
		<div class="activityarea-inner">
			<div class="actdata">
				<ActionSelect activity=prep action={prepared.action ?? null} onchange={change_prepared.bind('action')}/>
				<input id=prep_aim data-help="aim" type=text class="text" list="fighterList" placeholder="Ziel"
					value={prepared.aim} onchange={change_prepared.bind('aim')} />
				{#if user.isMaster}
					<p>{(duration) ? duration+" s" : ""}</p>
				{/if}
			</div>
			{#if showBehavior}
				<label for=charBehavior>Verhalten (autom. Handlungen):</label>
				<select id=charBehavior value={behavior} onchange={change_behavior} class=button>
					<option value="">keines</option>
					<option value="aggressiv">aggressiv</option>
					<option value="defensive">defensiv</option>
				</select>
			{/if}
		</div>
	</fieldset>

	<datalist id="fighterList"></datalist>
</div>


<script>
    import { user, game, send_request} from "../client.svelte.js";
    import {protoActions, impactHue} from "../core.js";
    import ActivityBox from "./ActivityBox.svelte";
    import ConcurrentBox from "./ConcurrentBox.svelte";
    import ActionSelect from "./ActionSelect.svelte";

    let prepared = $derived(view.persona.prepared)
    let showBehavior = $derived(user.isMaster && view.persona.affil !== 'fellow')
    let behavior = $derived(view.persona.behavior ?? "")
    let duration = $state(null)
    let maintains = $derived(view.persona.maintains.map(incidID => game.infos.get(incidID)))

    // $inspect(`COMBATTAB - maintains`, maintains)

    function change_prepared(e) {
        const attrib = (typeof this === 'string') ? this : ("_" in e.target.id) ? e.target.id.split("_")[1] : e.target.id
        const value = e.target.value ?? null
        send_request('prepare', {[attrib]: value}, "change prepares", (response) => {
            duration = response.dur ?? null;
        })
	}

    function change_behavior(e) {
        const value = (e.target.value !== "") ? e.target.value : null
        send_request('order', {action: 'BEHAVIOR', aim: value}, `switch behavior of ${view.persona} to ${value}`)
	}
</script>


<style lang="sass">
	@use "../colors" as colors

	/* tab with the activity boxes (ActivityBox, ConcurrentBox and the prepared box) */
	.combatPanel
		display: flex
		flex-flow: column nowrap
		gap: 20px
		padding: 20px 10px
		background-color: colors.$grey-50

		:global(h3)
			background-color: colors.$primary-040-black
			padding: 5px 0
			margin-bottom: 0
			text-align: center
			border-radius: 15px 15px 0 0

		:global(.activityarea)
			position: relative
			border-radius: 15px
			border: 2px solid colors.$primary-040-black
			box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
			break-inside: avoid
			background-color: colors.$grey-15
			padding: 0

			:global(h3)
				margin: 0

		:global(.activityarea-inner)
			padding: 20px 10px

	/* frame of the prepared box of this tab */
	.combatPanel .activityarea
		position: relative
		border-radius: 10px
		border: 2px solid black
		box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)
		margin: 6px
		break-inside: avoid


	.actdata
		display: grid
		justify-content: center
		grid-gap: 5px
		margin: 5px
		font-size: 1.2em

	.masterView .actdata
		grid-template-columns: 3fr 2fr 4ch

	.playerView .actdata
		grid-template-columns: 3fr 2fr

	.close
		float: right
		right: 8px
		top: 8px
		width: 16px
		height: 16px

	label
		margin: 8px
</style>